import React from "react";
import Grid from "@material-ui/core/Grid";
import {Machines} from "./Machines";
import {Button} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    actionRow: {
        display: 'flex',
        justifyContent: 'flex-end'
    }
}));

export const OrganizationUnitMachines = (props: any) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const navigate = useNavigate();
    const {organizationUnitId} = props;
    const moveMachines = () => {
        navigate(`/machines/move?returnUrl=/organization-units/${organizationUnitId}/detail?tab=1`);
    }
    return (
        <Grid container spacing={3}>
            <Grid container item xs={12} className={classes.actionRow}>
                <Button variant="contained" color="primary" size="medium"
                        onClick={moveMachines}>
                    {t('Machine.MoveMachines.Title')}
                </Button>
            </Grid>
            <Machines {...props}/>
        </Grid>
    );
};
